import { Container, Typography, Box, Paper, Button, IconButton } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import CloseIcon from '@mui/icons-material/Close';
import Hero from '../components/common/Hero';
import { Helmet } from 'react-helmet-async';
import { useState } from 'react';

const AnnualMeetingSlideshow = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  return (
    <>
      <Helmet>
        <title>2025 Annual HOA Meeting | Brynleigh Estates</title>
        <meta name="description" content="View the 2025 Annual HOA Meeting slideshow presentation for Brynleigh Estates community." />
        <link rel="canonical" href="https://brynleighestates.com/2025-annual-hoa-slideshow" />
      </Helmet>

      {/* Fullscreen overlay */}
      {isFullscreen && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bgcolor: 'rgba(0,0,0,0.95)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
            <IconButton
              onClick={() => setIsFullscreen(false)}
              sx={{ color: 'white' }}
              aria-label="Exit fullscreen"
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2 }}>
            <iframe
              src="https://gamma.app/embed/ikswvg45nn8l8m3"
              style={{ width: '100%', height: '100%', border: 'none' }}
              allow="fullscreen"
              title="Welcome to the Annual HOA Meeting"
            />
          </Box>
        </Box>
      )}

      <Hero
        imageUrl="/images/hills-bg.jpeg"
        title="2025 Annual HOA Meeting"
        subtitle="Welcome to the Annual Meeting Presentation"
      />

      <Container maxWidth="xl">
        <Box sx={{ my: 4 }}>
          <Paper
            elevation={0}
            sx={{
              p: 3,
              bgcolor: 'background.paper',
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'divider',
              textAlign: 'center'
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Box />
              <Typography variant="h5" fontWeight="medium" component="h1">
                Annual Meeting Presentation
              </Typography>
              <Button
                variant="outlined"
                startIcon={<FullscreenIcon />}
                onClick={() => setIsFullscreen(true)}
                size="small"
              >
                Fullscreen
              </Button>
            </Box>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              Use the controls below to navigate through the slideshow.
            </Typography>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                '& iframe': {
                  border: 'none',
                  borderRadius: 1,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }
              }}
            >
              <iframe
                src="https://gamma.app/embed/ikswvg45nn8l8m3"
                style={{ width: '100%', height: '70vh', minHeight: '500px' }}
                allow="fullscreen"
                title="Welcome to the Annual HOA Meeting"
              />
            </Box>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default AnnualMeetingSlideshow;
